import React, {  useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Accordion, AccordionSummary, AccordionDetails, Typography, Box, CircularProgress } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';

import { ExpandMore } from '@mui/icons-material';

import useErrorManager from "../../../hooks/useErrorManager";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";

import TextLinkButton from "../../Layout/TextLinkButton"
import GenericActionButton from '../../Layout/GenericActionButton';
import GenericDetailsTable from '../../Layout/Table/GenericDetailsTable';
import { manufacturersCode } from '../../../constants/manufacturersCode';

import { useNotification } from '../../../contexts/NotificationContext';

function GwRepeatersSection({ gatewayId }) {

    const navigate = useNavigate();
    const [repeatersList, setRepeatersList] = useState(null);
    
    const [loading, setLoading] = useState(true);

    const { setError, clearError, getError } = useErrorManager();
    const { showNotification } = useNotification();

    const axiosInstance = useAxiosPrivate();

    const repeatersTableColumns = [
        { field: 'serial', headerName: 'Serial Number', flex: 1 },
        { field: 'bat', headerName: 'Battery Level', flex: 1 },
        { field: 'rssi', headerName: 'Signal rating', flex: 1 },
        { field: 'type', headerName: 'Type', flex: 1 }


        // { field: 'manufacturerId', headerName: 'Manufacturer ID', flex: 1, renderCell: (params) => manufacturersCode[params.row.manufacturerId] || params.row.manufacturerId },
        // { field: 'identificationNr', headerName: 'Device ID', flex: 1, renderCell: (params) => (renderSecAddr(params.row.identificationNr)) },
        // { field: 'fabricationNr', headerName: 'Fabrication ID', flex: 1, renderCell: (params) => (renderSecAddr(params.row.fabricationNr)) },
        // { field: 'deviceVersion', headerName: 'Version', flex: 1 },
        // { field: 'deviceType', headerName: 'Device Type', flex: 1 },
        // { field: 'signalQuality', headerName: 'Signal rating', flex: 1 },
        // { field: 'siemeca', headerName: 'Reception level', flex: 1 }
    ];

    useEffect(() => {
        const fetchRepeatersList = async () => {
            try {
                const response = await axiosInstance.get(`/meters/scan/${gatewayId}/latest`);
                setRepeatersList(response.data);
                clearError('fetchRepeatersList');
            } catch (error) {
                setError('fetchRepeatersList', error.message);
                showNotification('Failed to fetch Repeaters List','error')
            } finally {
                setLoading(false); // Stop loading
            }
        };
        
        fetchRepeatersList();
    }, [gatewayId]);

    const renderSecAddr = (hexSecAddr) => {
        return hexSecAddr.toString(16);
    };
    
    const formatDateTime = (isoString) => {
        const date = new Date(isoString);
    
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const year = date.getFullYear();
    
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
    
        return `${day}/${month}/${year}, ${hours}:${minutes}:${seconds}`;
    };

    return (
        <>
            <Accordion defaultExpanded={false}>
                <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography variant="h7">REPEATERS INFORMATIONS</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    {loading ? ( 
                        // Show a loading spinner while data is being fetched
                        <Box display="flex" justifyContent="center" alignItems="center" height="100px">
                            <CircularProgress />
                        </Box>
                    ) : (
                                    <DataGrid 
                                        rows={repeatersList} 
                                        columns={repeatersTableColumns} 
                                        initialState={{
                                            pagination: {
                                                paginationModel: { pageSize: 5, page: 0 },
                                            },
                                        }}
                                        pageSizeOptions={[5, 10, 25]}
                                        getRowId={(row) => row.serial}
                                        localeText={{
                                            // override the default "No rows" label
                                            noRowsLabel: 'No repeaters found.',
                                        }}
                                    />
                    )}
                </AccordionDetails>

            </Accordion>
        </>     
    );
}

export default GwRepeatersSection;
